import { employeeApi } from "../../api";

export enum EmployeeFilterType {
    GENERAL = 'GENERAL',
    SALES = 'SALES',
    PENDING_SALES = 'PENDING_SALES',
    QUOTATIONS = 'QUOTATIONS',
}

const EmployeeService = {

    fetchDropdown: async (
        filterType: EmployeeFilterType = EmployeeFilterType.GENERAL
    ) => {

        const response = await employeeApi.fetchCustom(
            `/dropdown?filterType=${filterType}`
        );

        return response.data;

    },

};

export default EmployeeService;